/*
 * @Description: 首页楼层骨架
 * @Author: 蔺晨
 * @Date: 2020-12-22
 */
import React, { Component } from 'react';
import Shape from './Shape';
import { Flex } from 'antd-mobile';

// @withRouter
export default class FloorFrame extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <Flex justify="between" style={{ margin: '0 30px 30px', flexWrap: 'wrap' }}>
        {[1, 2, 3, 4].map((item) => (
          <Shape
            isFlash={false}
            w="calc(50vw - 30px - 8px)"
            style={{
              flexShrink: '0',
              padding: '16px',
              border: '1px solid rgba(0, 0, 0, .1)',
              marginBottom: '14px',
              background: 'none'
            }}>
            <Shape w="100%" h="calc(50vw - 30px - 32px - 8px)" />
            <Flex
              direction="column"
              align="center"
              justify="center"
              style={{ padding: '26px 0 6px' }}>
              <Shape w="76%" h="36px" />
              <Shape w="88%" h="40px" style={{ marginTop: '20px' }} />
            </Flex>
          </Shape>
        ))}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/FloorFrame.js